import { RewardType } from '@betty/rewards';

export const REWARD_IMAGES: Partial<
  Record<RewardType, keyof RegisteredImages['promos']>
> = {
  Cash: 'cashOrBonus',
  Bonus: 'cashOrBonus',
  Coins: 'bettyPromoCoins',
  InstantWheel: 'bettyPromoWheel',
};

export const REWARD_IMAGE_SIZE = 24;
